import { type RefObject, useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

/**
 * This utility computes the position of a module/block in the viewport
 * The computing starts when it enters inside and stops when it goes out
 */
export const useScrollPosition = (moduleRef: RefObject<HTMLDivElement>, debounceValue = 10) => {
  const [moduleScrollPosition, setModuleScrollPosition] = useState<{ yPosition: number } | null>(
    null,
  );

  const handleScroll = () => {
    const moduleBounding = moduleRef?.current?.getBoundingClientRect();

    // Once we see the module in the viewport, we start computing
    if (moduleBounding && Math.abs(moduleBounding.y) <= window.innerHeight) {
      setModuleScrollPosition({
        yPosition: moduleBounding.y,
      });
    } else {
      // And we stop when the module is out
      setModuleScrollPosition(null);
    }
  };

  useEffect(() => {
    // The debounce helps computing less (better for the JS heap size)
    window.addEventListener('scroll', debounce(handleScroll, debounceValue));

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return moduleScrollPosition;
};
